import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';

import { homeMessages } from 'src/features/home/utils/messages';
import { Badge } from 'src/registry/ui/Badge';
import { ICON_MAP } from 'src/utils/constants';

type Props = {
    value?: number;
};

export default function ComparisonBadge({ value }: Props) {
    return (
        <div className="flex justify-center gap-1 text-sm">
            <FormattedMessage {...homeMessages.comparedToLastDay} />
            <Badge theme={value ? (value > 0 ? 'green' : 'red') : 'gray'} className="gap-1 px-1">
                <FontAwesomeIcon
                    icon={value ? (value > 0 ? ICON_MAP.ARROW_UP : ICON_MAP.ARROW_DOWN) : ICON_MAP.MINUS}
                />
                {value !== 0 && value}%
            </Badge>
        </div>
    );
}
